import { render } from "./ModalAutorAgregar.vue?vue&type=template&id=040893d2&scoped=true"
import script from "./ModalAutorAgregar.vue?vue&type=script&lang=js"
export * from "./ModalAutorAgregar.vue?vue&type=script&lang=js"

import "@/assets/styles/modal-styles.css?vue&type=style&index=0&id=040893d2&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040893d2"]])

export default __exports__